// extracted by mini-css-extract-plugin
module.exports = {"container":"social-widgets_container__B5bcQ"};